import { useFeatureFlags } from 'v2/shared/hooks/use-feature-flags'
import { usePermissions } from 'v2/shared/hooks/use-permissions'
import { useUserPlan } from 'v2/shared/hooks/use-plan'
import { RbacModules, RbacPermissionTypes } from 'v2/types/rbac'
import { canViewSandboxTab } from './sandbox-gate'

/**
 * The one sandbox-eligibility decision, so no surface computes it twice.
 */
export const useSandboxSetupVisible = (): boolean => {
  const { isTrial, isPlanLoaded } = useUserPlan()
  const { isVoiceSandboxEnabled } = useFeatureFlags()
  const { permissions } = usePermissions()

  return canViewSandboxTab({
    isVoiceSandboxEnabled,
    isTrial,
    isPlanLoaded,
    hasCallChannelView: Boolean(
      permissions?.[RbacModules.channelCalls]?.[RbacPermissionTypes.view],
    ),
  })
}
